import { ErrorResponseBody } from '../api-clients';
import {BaseError} from "../../errors/BaseError";

/**
 * サーバーエラー例外
 */
export class ApiServerError extends BaseError {
  public readonly status: number;

  public readonly code: number;

  public readonly message: string;

  constructor(body: ErrorResponseBody, status: number) {
    super(body.message);

    this.status = status;
    this.code = body.code;
    this.message = body.message;
  }
}